import React from 'react';
import { Typography, Box, Row, Col, Input } from '@lucid/lego';
import { useStore } from '../../../store/store';
import styles from './LocateAsset.module.scss';
import carImage from '../../../assets/lucid_car.png';
import { useState } from 'react';

// Dummy data
const assetData = [
  {
    vehicle: {
      year: '2023',
      model: 'Lucid Air Pure',
      image: carImage,
    },
    contacts: [
      { label: 'VIN Number', value: '50EA1TEA0PA00444' },
      { label: 'Model', value: 'V2.107' },
      { label: 'Run', value: '624km' },
      { label: 'Phone', value: 'Lux Midnight' },
      { label: 'Type', value: 'Active' },
      { label: 'Battery Capacity', value: '2,000kwh' },
    ],
  },
  {
    vehicle: {
      year: '2023',
      model: 'Lucid Air Pure',
      image: carImage,
    },
    contacts: [
      { label: 'VIN Number', value: '60EA1TEA0PA00444' },
      { label: 'Model', value: 'V2.107' },
      { label: 'Run', value: '624km' },
      { label: 'Phone', value: 'Lux Midnight' },
      { label: 'Type', value: 'Active' },
      { label: 'Battery Capacity', value: '2,000kwh' },
    ],
  },
];

const CustomerCareLocateAsset: React.FC = () => {
  const theme = useStore((state) => state.theme);
  const [searchQuery, setSearchQuery] = useState<string>('');
  return (
    <Box pl={32} ml={8} mr={8} pt={24} pr={32}>
      <Box mt={8}>
        <Input
          name="search"
          type="text"
          placeholder="Search: VIN / Name / Tel No. / Licence Plate ..."
          theme={theme}
          size="medium"
          controlled={true}
          helperIcon={{
            category: 'global',
            name: 'search',
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </Box>
      <Row gutter={[24, 0]} className={styles.assetListContainer}>
        {assetData.map((asset, assetIndex) => (
          <Col xs={12} sm={12} lg={12} key={assetIndex}>
            <Box
              background="white"
              pb={32}
              pl={24}
              pr={24}
              pt={32}
              className={styles.cardContainer}
            >
              <Box mb={16}>
                <Typography variant="h3" size="medium" color="black" theme={theme}>
                  {asset.vehicle.year} {asset.vehicle.model}
                </Typography>
              </Box>
              <Row gutter={[24, 24]} className={styles.stretchRow}>
                <Col xs={12} sm={12} md={5} lg={5}>
                  <Box className={styles.imageBox}>
                    <img
                      src={asset.vehicle.image}
                      alt={`${asset.vehicle.year} ${asset.vehicle.model}`}
                      className={styles.vehicleImage}
                    />
                  </Box>
                </Col>
                <Col xs={12} sm={12} md={7} lg={7}>
                  <Box pl={24} pr={24} pt={24} pb={24} className={styles.innerCard}>
                    <Row gutter={[16, 16]}>
                      {asset.contacts.map((contact, index) => (
                        <Col xs={12} sm={6} md={6} lg={6} key={index}>
                          <Box>
                            <Typography variant="body" size="small" color="gray-5" theme={theme}>
                              {contact.label}
                            </Typography>
                            <Typography variant="body" size="medium" color="black" theme={theme}>
                              {contact.value}
                            </Typography>
                          </Box>
                        </Col>
                      ))}
                    </Row>
                  </Box>
                </Col>
              </Row>
            </Box>
          </Col>
        ))}
      </Row>
    </Box>
  );
};

export default CustomerCareLocateAsset;
